import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const POISHeatmapApi = createApi({
	reducerPath: "POISHeatMap",
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.REACT_APP_BACKEND2_URL,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
		credentials: "include",
	}),
	endpoints: (builder) => ({
		getPOIHeatMap: builder.query({
			query: ({ fromDate, toDate }) => {
				return `v1/poiHeatMap?fromDate=${fromDate}&toDate=${toDate}`;
			},
		}),
	}),
});

export const { useGetPOIHeatMapQuery, useLazyGetPOIHeatMapQuery } =
	POISHeatmapApi;
